/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_listen_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTEN's six letters — L, I, S, T, E, N — rearrange into four full anagrams: SILENT, ENLIST, TINSEL, and INLETS. Shorter words hiding inside the same letters include LINE, LENT, TIE, NET, SIT, TIN, and ITS, all spelled using only letters already in LISTEN.`)
};

const es_wu_c_listen_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las seis letras de LISTEN —L, I, S, T, E, N— se reordenan en cuatro anagramas completos: SILENT, ENLIST, TINSEL e INLETS. Entre las palabras más cortas escondidas en esas mismas letras están LINE, LENT, TIE, NET, SIT, TIN e ITS, todas formadas solo con letras que ya están en LISTEN.`)
};

const de_wu_c_listen_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTENs sechs Buchstaben — L, I, S, T, E, N — lassen sich zu vier vollständigen Anagrammen umstellen: SILENT, ENLIST, TINSEL und INLETS. Kürzere Wörter, die sich in denselben Buchstaben verstecken, sind unter anderem LINE, LENT, TIE, NET, SIT, TIN und ITS — alle nur mit Buchstaben geschrieben, die LISTEN bereits enthält.`)
};

const nl_wu_c_listen_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTEN's zes letters — L, I, S, T, E, N — vormen samen vier volledige anagrammen: SILENT, ENLIST, TINSEL en INLETS. Kortere woorden die in dezelfde letters verstopt zitten zijn onder andere LINE, LENT, TIE, NET, SIT, TIN en ITS, allemaal gespeld met alleen letters die al in LISTEN zitten.`)
};

const fr_wu_c_listen_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les six lettres de LISTEN — L, I, S, T, E, N — se réarrangent en quatre anagrammes complets : SILENT, ENLIST, TINSEL et INLETS. Des mots plus courts se cachent dans ces mêmes lettres, notamment LINE, LENT, TIE, NET, SIT, TIN et ITS, tous formés uniquement à partir des lettres déjà présentes dans LISTEN.`)
};

const it_wu_c_listen_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le sei lettere di LISTEN — L, I, S, T, E, N — si ricombinano in quattro anagrammi completi: SILENT, ENLIST, TINSEL e INLETS. Tra le parole più corte nascoste nelle stesse lettere ci sono LINE, LENT, TIE, NET, SIT, TIN e ITS, tutte scritte usando solo lettere già presenti in LISTEN.`)
};

const pt_br2_wu_c_listen_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As seis letras de LISTEN — L, I, S, T, E, N — se rearranjam em quatro anagramas completos: SILENT, ENLIST, TINSEL e INLETS. Palavras mais curtas escondidas nas mesmas letras incluem LINE, LENT, TIE, NET, SIT, TIN e ITS, todas formadas usando apenas letras já presentes em LISTEN.`)
};

const pt_wu_c_listen_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As seis letras de LISTEN — L, I, S, T, E, N — reorganizam-se em quatro anagramas completos: SILENT, ENLIST, TINSEL e INLETS. Entre as palavras mais curtas escondidas nas mesmas letras estão LINE, LENT, TIE, NET, SIT, TIN e ITS, todas soletradas apenas com letras já presentes em LISTEN.`)
};

const ja_wu_c_listen_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTENの6文字 — L, I, S, T, E, N — を並べ替えると、SILENT、ENLIST、TINSEL、INLETSという4つの完全なアナグラムができます。同じ文字の中に隠れている短い単語には、LINE、LENT、TIE、NET、SIT、TIN、ITSなどがあり、いずれもLISTENにすでに含まれる文字だけで綴られています。`)
};

const zh_wu_c_listen_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LISTEN 的六个字母——L、I、S、T、E、N——可以重新排列成四个完整的易位构词：SILENT、ENLIST、TINSEL 和 INLETS。藏在这些字母中的较短单词还包括 LINE、LENT、TIE、NET、SIT、TIN 和 ITS，全部只用到 LISTEN 本身已有的字母。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_listen_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_listen_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_listen_faq1_a", locale)
	if (locale === "en") return en_wu_c_listen_faq1_a(inputs)
	if (locale === "es") return es_wu_c_listen_faq1_a(inputs)
	if (locale === "de") return de_wu_c_listen_faq1_a(inputs)
	if (locale === "nl") return nl_wu_c_listen_faq1_a(inputs)
	if (locale === "fr") return fr_wu_c_listen_faq1_a(inputs)
	if (locale === "it") return it_wu_c_listen_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_listen_faq1_a(inputs)
	if (locale === "pt") return pt_wu_c_listen_faq1_a(inputs)
	if (locale === "ja") return ja_wu_c_listen_faq1_a(inputs)
	return zh_wu_c_listen_faq1_a(inputs)
};